import { useFormaliteService } from '@europrocurement/l2d-domain';
import {
    type DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup,
    type DossierOpenSearchJsonldOpensearchDossierClientRead,
    type DossierApiApiDossiersIdPatchRequest,
} from '@europrocurement/l2d-domain/openApi/ApiFormalite';

export type DossierClient = DossierOpenSearchJsonldOpensearchDossierClientRead &
    Record<string, unknown>;

const useDossierClient = () => {
    const { dossierOpenSearchApi, dossierApi } = useFormaliteService();
    let searchClientTimeout: number | undefined;

    const searchDossierClient = (term: string): Promise<Array<DossierClient>> =>
        new Promise((resolve, reject) => {
            clearTimeout(searchClientTimeout);
            const requestParameters = { q: term || undefined };

            searchClientTimeout = setTimeout(() => {
                dossierOpenSearchApi
                    .apiOpensearchClientsGetCollection(requestParameters)
                    .then((res) => resolve(res.data['hydra:member'] as Array<DossierClient>))
                    .catch(() => reject());
            }, 300);
        });

    const updateDossierClientOpere = (
        dossierId: number,
        clientOpereId: number,
    ): Promise<DossierJsonldDossierReadNoteGroupTimestampableBlameambleGroup> => {
        const requestParameters: DossierApiApiDossiersIdPatchRequest = {
            id: dossierId.toString(),
            dossierDossierUpdatePartial: {
                clientOpere: clientOpereId,
            },
        };

        return dossierApi.apiDossiersIdPatch(requestParameters).then((res) => res.data);
    };

    return { searchDossierClient, updateDossierClientOpere };
};

export default useDossierClient;
